import { render, staticRenderFns } from "./jobfairconfirm.vue?vue&type=template&id=cd0b88a2&scoped=true"
import script from "./jobfairconfirm.vue?vue&type=script&lang=js"
export * from "./jobfairconfirm.vue?vue&type=script&lang=js"
import style0 from "./jobfairconfirm.vue?vue&type=style&index=0&id=cd0b88a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0b88a2",
  null
  
)

export default component.exports